import { render, staticRenderFns } from "./SettingsOption.vue?vue&type=template&id=1647c8b2&scoped=true&"
import script from "./SettingsOption.vue?vue&type=script&lang=js&"
export * from "./SettingsOption.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOption.vue?vue&type=style&index=0&id=1647c8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647c8b2",
  null
  
)

export default component.exports